import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular';
import { CustomListRangePopoverComponent } from './custom-list-range-popover.component';

@NgModule({
  declarations: [CustomListRangePopoverComponent],
  exports: [CustomListRangePopoverComponent],
  imports: [CommonModule, IonicModule, FontAwesomeModule],
})
export class CustomListRangePopoverModule {}